import React, { useState } from 'react';
import PropTypes from 'prop-types';

import TextInput from '@xingternal/malt-text-input';
import { IconShow, IconHide } from '@xingternal/designkit';

import withActionTracker from '../../Components/PageviewTracker/withActionTracker';

import styles from './PasswordField.css';

const ToggleVisibleButton = ({ onClick, isVisible }) => (
  <span className={styles.iconButton} onClick={onClick}>
    {isVisible ? (
      <IconShow width={24} height={24} />
    ) : (
      <IconHide width={24} height={24} />
    )}
  </span>
);

ToggleVisibleButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  isVisible: PropTypes.bool.isRequired,
};

const PasswordField = ({
  error,
  label,
  handleChange,
  inputRef,
  value,
  autoFocus,
  track,
}) => {
  const [isVisible, setIsVisible] = useState(false);
  const toggleIsVisible = () => {
    if (!isVisible) {
      track('welcome_login_password_show_click');
    }

    setIsVisible(!isVisible);
  };

  return (
    <TextInput
      required
      size={'m'}
      value={value}
      label={label}
      name={'password'}
      inputRef={inputRef}
      autoFocus={autoFocus}
      onChange={handleChange}
      className={styles.noMargin}
      message={error}
      type={isVisible ? 'text' : 'password'}
      icon={() => (
        <ToggleVisibleButton onClick={toggleIsVisible} isVisible={isVisible} />
      )}
    />
  );
};

PasswordField.propTypes = {
  error: PropTypes.oneOf([PropTypes.string, PropTypes.object]),
  handleChange: PropTypes.func.isRequired,
  className: PropTypes.string,
  autoFocus: PropTypes.bool,
  inputRef: PropTypes.object,
  label: PropTypes.element,
  value: PropTypes.string,
  track: PropTypes.func,
};

export default withActionTracker(PasswordField);
